import { Link, useLocation } from "react-router-dom";
import hewlett from "../../assests/HPE/Landing-page/hpe-cloud/logo.svg";
import zertoLogo from "../../assests/HPE/zerto/logo.svg";
import EnterpriseHeader from "../ui/enterprise1/EnterpriseHeader";
import frame from "../../assests/HPE/enterpriseone/ent-a/Frame 1171275854.svg";
import hpe from "../../assests/HPE/enterpriseone/ent-a/HPE-logo-full-clr-pos-rgb (3) 1.png";

const Header = () => {
  const location = useLocation(); // gives current URL path

  // Map routes to logos (texts in this case)
  // const logos = {
  //   "/": { text: "Hybrid cloud software portfolio", link: "/" },
  //   "/thank-you": { text: "Hybrid cloud software portfolio", link: "/" },
  //   "/zerto": { text: "hpe zerto software", link: "/zerto" },
  //   "/zerto/thank-you": { text: "hpe zerto software", link: "/zerto" },
  // };

  // // Default to "title" if route not listed
  // const { text: logoText, link: logoLink } = logos[location.pathname] || {
  //   text: "HPE CLOUD SOFTWARE PORTFOLIO",
  //   link: "/",
  // };

  const logos = {
    "/": { text: "Hybrid cloud software portfolio", link: "/", logo: hewlett },
    "/thank-you": {
      text: "Hybrid cloud software portfolio",
      link: "/",
      logo: hewlett,
    },
    "/zerto": { text: "hpe zerto software", link: "/zerto", logo: zertoLogo },
    "/zerto/thank-you": {
      text: "hpe zerto software",
      link: "/zerto",
      logo: zertoLogo,
    },
  };

  // Default to "title" if route not listed
  const { link: logoLink, logo } = logos[location.pathname] || {
    text: "HPE CLOUD SOFTWARE PORTFOLIO",
    link: "/",
    logo: hewlett,
  };

  return (
    <header className="absolute top-0 left-0 w-full z-20">
      <div className="bg-white flex flex-col gap-2">
        <div className="pb-5 px-4 md:px-16 flex gap-6 items-center justify-center">
          <Link to={logoLink}>
            {/* <img src={logo} alt="hewlett" className="max-h-5 md:max-h-6" /> */}
            {/* <EnterpriseHeader /> */}
            <div className="w-full pt-5 pb-4 flex justify-center">
              <div
                className="
                flex md:inline-flex
                items-center justify-center
                gap-[46.588px] md:gap-[72px]
                px-[15.529px] py-[12.941px] md:px-6 md:py-5
                rounded-[64.706px] md:rounded-[100px]
                bg-grey-01
                w-full max-w-[338px] md:max-w-fit
                m-auto 
              "
              >
                <div className="flex h-[18.118px] items-center gap-[12.94px] md:h-7 md:gap-5">
                  {/* LEFT LOGO */}
                  <span className="flex items-center">
                    <img src={frame} alt="" className="w-[66px] h-auto" />
                  </span>

                  {/* DIVIDER */}
                  <span className="w-[1.75px] h-[24px] bg-grey-02" />

                  {/* RIGHT SECTION */}
                  <span className="flex items-center gap-4">
                    <img
                      src={hpe}
                      alt=""
                      className="w-[56px] h-[16px] object-contain"
                    />

                    <p className="text-grey-06 text-[13px] md:text-[18px] leading-[26px] font-google font-normal">
                      SOLUTION PROVIDER
                    </p>
                  </span>
                </div>
              </div>
            </div>
          </Link>
          {/* <div className="flex items-center justify-center">
            <Link
              to={logoLink}
              className="flex items-center justify-center gap-x-5"
            >
              <span className="text-grey-06 uppercase">{logoText}</span>
            </Link>
          </div> */}
        </div>
      </div>
    </header>
  );
};

export default Header;
